export const TARGET_STEP_PARAM = 'stepTargetId';
export const PREMIUM_URL = 'https://premium.wix.com/wix/api/premiumStart';
export const WIX_DASHBOARD_URL = 'https://manage.wix.com/dashboard';
export const WIX_META_SITE_ID_HEADER = 'x-wix-msid';
export const STORES_APP_DEF_ID = '215238eb-22a5-4c36-9e7b-e7c08025e04e';
export const WIX_LOGIN_URL = 'https://users.wix.com/signin/signup/password';
